import { getAdminDashboard as getAdminDashboardRequest } from "../../domain/admin"

export const ADMIN_SET = "ADMIN_SET"
export const ADMIN_REQUEST = "ADMIN_REQUEST"
export const ADMIN_REQUEST_DONE = "ADMIN_REQUEST_DONE"

export const setAdmin = data => ({ type: ADMIN_SET, payload: data })

export const adminRequest = () => ({ type: ADMIN_REQUEST })

export const adminRequestDone = () => ({ type: ADMIN_REQUEST_DONE })

export const getAdminDashboard = () => dispatch => {
	dispatch(adminRequest())
	return getAdminDashboardRequest().then(res => {
		dispatch(setAdmin(res.data.data))
		dispatch(adminRequestDone())
		return res.data.data
	})
}
